import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import './Caption.sass'

class Caption extends PureComponent {
  static propTypes = {
    position: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.node.isRequired
  }

  static defaultProps = {
    position: 'left',
    type: 'h1',
    className: ''
  }

  render() {
    const {position, children, className, type} = this.props
    if (type == 'h1') {
      return (
        <h1 className={`base-caption base-caption--${position} ${className}`}>{children}</h1>
      )
    } else if (type == 'h2'){
      return (
        <h2 className={`base-caption base-caption--${position} ${className}`}>{children}</h2>
      )
    } else if (type == 'h3'){
      return (
        <h3 className={`base-caption base-caption--${position} ${className}`}>{children}</h3>
      )
    } else if (type == 'h4'){
      return (
        <h4 className={`base-caption base-caption--${position} ${className}`}>{children}</h4>
      )
    } else if (type == 'h5'){
      return (
        <h5 className={`base-caption base-caption--${position} ${className}`}>{children}</h5>
      )
    }
  }
}

export default Caption


// WEBPACK FOOTER //
// ./components/Caption/index.jsx